"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BigNum = require("@liskhq/bignum");

exports.BIG_ENDIAN = 'big';
exports.LITTLE_ENDIAN = 'little';

exports.intToBuffer = function (value, byteLength) {
  var endianness = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : exports.BIG_ENDIAN;
  return new BigNum(value).toBuffer({
    size: byteLength,
    endian: endianness
  });
};

exports.bufferToIntAsString = function (buffer) {
  return BigNum.fromBuffer(buffer).toString();
};

exports.bigNumberToBuffer = function (bignumber, size) {
  var endian = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : exports.BIG_ENDIAN;
  return exports.intToBuffer(bignumber, size, endian);
};

exports.bufferToBigNumberString = function (bigNumberBuffer) {
  return exports.bufferToIntAsString(bigNumberBuffer);
};

exports.bufferToHex = function (buffer) {
  return Buffer.from(buffer).toString('hex');
};

var hexRegex = /^[0-9a-f]+/i;

exports.hexToBuffer = function (hex) {
  var argumentName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Argument';

  if (typeof hex !== 'string') {
    throw new TypeError("".concat(argumentName, " must be a string."));
  }

  var matchedHex = (hex.match(hexRegex) || [])[0];

  if (!matchedHex || matchedHex.length !== hex.length) {
    throw new TypeError("".concat(argumentName, " must be a valid hex string."));
  }

  if (matchedHex.length % 2 !== 0) {
    throw new TypeError("".concat(argumentName, " must have a valid length of hex string."));
  }

  return Buffer.from(matchedHex, 'hex');
};